import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { USER_ROLES } from 'constants/common';

import { userSelector } from 'store/auth/selectors';

import { Icon } from 'components/shared/Icon';
import { Typography } from 'components/shared/Typography';

import { getMenuItems } from './Menu.config';

import styles from './Menu.module.scss';

const Menu = ({ className, collapsed }: { className: any; collapsed: any }) => {
  const user = useSelector(userSelector);
  const { i18n } = useTranslation();

  const items = useMemo(
    () =>
      getMenuItems().filter((menuItem: any) => {
        if (menuItem.key === 'schools' && user.role !== USER_ROLES.ROOT_ADMIN) {
          return false;
        }

        if (menuItem.key === 'school' && user.role === USER_ROLES.ROOT_ADMIN) {
          return false;
        }

        if (menuItem.key === 'dashboard' && user.role !== USER_ROLES.ROOT_ADMIN) {
          return false;
        }

        if (menuItem.key === 'analytics' && user.role !== USER_ROLES.ROOT_ADMIN) {
          return false;
        }

        return true;
      }),
    [i18n.language, user.role],
  );

  return (
    <div className={cn(styles.menu, className)}>
      {items.map((menuItem: any) => (
        <NavLink
          className={({ isActive }: { isActive: any }) =>
            isActive ? cn(styles.item, styles.itemActive) : styles.item
          }
          key={menuItem.key}
          to={menuItem.to}
        >
          <Icon className={styles.icon} name={menuItem.icon} />
          {!collapsed && (
            <Typography
              className={styles.text}
              variant="body1"
              weight="medium"
              mode="compact"
            >
              {menuItem.text}
            </Typography>
          )}
        </NavLink>
      ))}
    </div>
  );
};

export default React.memo(Menu) as any;
